'use client';

import React, { Component } from 'react';
import { Container, Button } from 'reactstrap';

class SkipToMainContent extends Component {
    constructor(props) {
        super(props);
    }

    focusFirstFocusableInsideMain = () => {
        const main = document.getElementById('body');
        if (!main) return;

        const selector = `
      a[href], button, input, textarea, select,
      [tabindex]:not([tabindex="-1"]), [contenteditable="true"]
    `;

        const focusables = Array.from(main.querySelectorAll(selector)).filter(
            el => !el.disabled && el.offsetParent !== null
        );
        console.log("focusables",focusables);
        if (focusables.length > 0) {
            focusables[0].focus();
        }
    };

    handleClick = () => {
        if (typeof document === 'undefined') return;

        const main = document.getElementById('body');
        if (main) {
            // Move focus to <main>
            main.focus({ preventScroll: true });

            // Scroll main into view
            main.scrollIntoView({ behavior: 'smooth', block: 'start' });

            // Then focus the first focusable element inside main
            setTimeout(() => {
                this.focusFirstFocusableInsideMain();
            }, 50);
        }
    };

    render() {
        return (
            <div className="skip-to-main-wrapper">
                <Container className="d-flex justify-content-center align-items-center">
                    <div tabIndex={-1} className="skip-container" style={{ position: 'relative' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            className="skip-main-btn"
                            onClick={this.handleClick}>
                            Skip to main content
                        </Button>
                    </div>
                </Container>
            </div>
        );
    }
}

export default SkipToMainContent;
